import { render } from "./bracket-roundRobin.vue?vue&type=template&id=6c2b0406"
import script from "./bracket-roundRobin.vue?vue&type=script&lang=js"
export * from "./bracket-roundRobin.vue?vue&type=script&lang=js"

import "./bracket-roundRobin.vue?vue&type=style&index=0&id=6c2b0406&lang=scss"

import exportComponent from "/usr/src/app/frontend_result/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__